import { Component, OnInit } from '@angular/core';
import { DataSourceCard } from '../../models/data-connection';
import { EventEmitter, Output } from '@angular/core';
import { DataSourceCards } from '../../models/connection-dataset';
import { UserManagementService } from '../../../shared/services/user-management.service';
import { ApiService } from '../../../shared/services/api.service';
import { ConnectionType, GetDataConnectionListQuery, GetDataConnectionListQueryVariables } from '../../../../API';
import { GetDataConnectionList } from '../../../../graphql/queries';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-datasource-selection',
  templateUrl: './datasource-selection.component.html',
  styleUrl: './datasource-selection.component.scss',
})
export class DatasourceSelectionComponent implements OnInit {
  cardDetails: DataSourceCard[] = DataSourceCards;
  selectedDatasourceModel?: string | null;
  @Output() datasourceSelect = new EventEmitter<any>();
  isSFTPConnectionPresent: boolean = false;
  isBucketAssigned: boolean = false;
  isLoading = false;
  isDatabricksConnectionAllowed: boolean = false;

  constructor(
    private userManagementService: UserManagementService,
    private apiService: ApiService,
    private nzMessageService: NzMessageService,
  ) {}

  ngOnInit(): void {
    const bucketName = this.userManagementService.getBucketName();
    this.isDatabricksConnectionAllowed = this.userManagementService.isDatabricksConnectionAllowed();
    if (bucketName) {
      this.isBucketAssigned = true;
    }
    this.isLoading = true;
    this.apiService
      .query<GetDataConnectionListQuery, GetDataConnectionListQueryVariables>(GetDataConnectionList, {
        orgType: this.userManagementService.getOrgType(),
      })
      .then((response) => {
        const parentTableData = response.data?.GetDataConnectionList.dataConnectionList as any;
        this.isSFTPConnectionPresent = parentTableData.some((conn: any) => conn.connectionType === ConnectionType.SFTP);
      })
      .catch((error) => {
        this.nzMessageService.error(`Error Fetching Data Connection ${error?.message}`);
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  onDatasourceSelectionChange() {
    const selectedCard = this.cardDetails.find((card) => card.key === this.selectedDatasourceModel);
    this.datasourceSelect.emit({
      selectedDatasource: selectedCard,
    });
  }

  proceedCreateDatasource() {
    const selectedCard = this.cardDetails.find((card) => card.key === this.selectedDatasourceModel);
    this.datasourceSelect.emit({
      selectedDatasource: selectedCard,
      stepper: 1,
    });
  }

  isDisabled(item: DataSourceCard): boolean {
    if (item.isDisabled) {
      item.tooltip = 'This feature is not yet implemented.';
      return true;
    }

    if (item.key === ConnectionType.SFTP) {
      if (!this.isBucketAssigned) {
        item.tooltip =
          'SFTP connection creation is restricted for your organization. To request access, contact the NFL admin.';
        return true;
      }
      if (this.isSFTPConnectionPresent) {
        item.tooltip = 'Only one SFTP connection is allowed per organization.';
        return true;
      }
    }

    if (item.key === ConnectionType.DATABRICKS) {
      if (!this.isDatabricksConnectionAllowed) {
        item.tooltip =
          'Databricks connection creation is restricted for your organization. To request access, contact the NFL admin.';
        return true;
      }
    }
    item.tooltip = '';
    return false;
  }
}
